import React from "react";

type Props = {
  width: number;
};
export const PersonSVG: React.FC<Props> = ({ width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 11.878 25.832"
    >
      <g
        id="グループ_19"
        data-name="グループ 19"
        transform="translate(-63.245 -940.493)"
      >
        <path
          id="パス_94"
          data-name="パス 94"
          d="M28.188,22.381a4.174,4.174,0,1,0,4.174-4.174,4.174,4.174,0,0,0-4.174,4.174"
          transform="translate(36.822 922.286)"
        />
        <path
          id="パス_95"
          data-name="パス 95"
          d="M34.289,33.733H28.484a3.036,3.036,0,0,0-3.036,3.037v9.756a3.036,3.036,0,0,0,3.036,3.037h5.805a3.037,3.037,0,0,0,3.037-3.037V36.77a3.037,3.037,0,0,0-3.037-3.037"
          transform="translate(37.797 916.763)"
        />
      </g>
    </svg>
  );
};
